import { render, staticRenderFns } from "./new-doc-icon.vue?vue&type=template&id=69bab9a9&"
import script from "./new-doc-icon.vue?vue&type=script&lang=js&"
export * from "./new-doc-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports